module.exports = __webpack_public_path__ + "static/logo-dark-222fd61ae76fa91cabd203c44057d8bb.svg";